import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  input,
  inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-item-direct-select',
  templateUrl: './item-direct-select.component.html',
  styleUrls: ['./item-direct-select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ItemDirectSelectComponent),
      multi: true,
    },
  ],
})
export class ItemDirectSelectComponent<T extends Record<string, unknown> = Record<string, unknown>>
  implements ControlValueAccessor
{
  private readonly cdr = inject(ChangeDetectorRef);

  readonly items = input<T[]>([]);
  readonly bindLabel = input<string>('name');
  readonly placeholder = input<string>('Seleccione');
  readonly notFoundText = input<string>('No se encontraron resultados');
  readonly label = input<string>();
  readonly compareWith = input<(a: T | null, b: T | null) => boolean>();

  value: T | null = null;
  disabled = false;
  private onChange: (value: T | null) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: T | null): void {
    this.value = value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (value: T | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelect(item: T | null): void {
    this.value = item;
    this.onChange(item);
    this.onTouched();
    this.cdr.markForCheck();
  }
}
